const styles = (theme) => ({
  shareIcon: {
    backgroundColor: "#fff",
  },
});

export default styles;
